import React from "react";
import { IconButton as MuiIconButton, IconButtonProps } from "@mui/material";
import { color } from "../../styles";

interface ExtendedIconButtonProps extends IconButtonProps {
    clicked?: boolean;
}

const ForwardedIconButton = React.forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
    (props, ref) => {
        const { style, clicked, children, ...rest } = props;
        const backgroundColor = clicked ? color.status.INFO_LIGHT : "";

        return (
            <MuiIconButton
                ref={ref}
                style={{
                    padding: "0",
                    alignItems: "center",
                    backgroundColor,
                    ...style,
                }}
                {...rest}
            >
                {children}
            </MuiIconButton>
        );
    }
);

export default ForwardedIconButton;
